import React from 'react';
import { Button, Typography, BaseIcon } from '@scale/scaleui';
import { Link } from 'react-router-dom';
import { Routes } from 'react-scale/components/GrowthCenter/urls';
import { EmailDripCampaignListTab } from 'react-scale/components/GrowthCenter/constants';

const METRICS_DASHBOARD_URL = 'https://redash.scale.com/dashboards/4430';

interface HeaderProps {
  currentTab: string;
}

const Header: React.FC<HeaderProps> = ({ currentTab }) => {
  return (
    <div className="flex flex-row justify-between w-full gap-5 items-center">
      <div>
        <Typography.H4>Communications</Typography.H4>
        <Typography.Paragraph2 className="mr-2">
          Check communication-wide stats in{' '}
          <a href={METRICS_DASHBOARD_URL} target="_blank" rel="noopener noreferrer">
            Redash
          </a>{' '}
          by communication name
        </Typography.Paragraph2>
      </div>
      {currentTab !== EmailDripCampaignListTab.LifecycleCommunications && (
        <div className="min-w-[150px]">
          <Link to={Routes.CommunicationSetup}>
            <Button size="lg" variant="primary">
              <BaseIcon contrastText edge="start" icon={['fas', 'plus']} />
              New Communication
            </Button>
          </Link>
        </div>
      )}
    </div>
  );
};

export default Header;
